import SaleRegisterContainer from './SaleRegisterContainer';

export default SaleRegisterContainer;
